export default function SpiritoryLabel(
  props: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  > & { required?: boolean }
) {
  const { required, ...rest } = props;
  return (
    <label
      {...rest}
      className="tw-font-plusJakartaSans tw-font-semibold tw-text-base tw-leading-[20.16px] tw-text-slate-gray max-nine:tw-text-xs-custom"
    >
      {props.children}{' '}
      {required && <span className="tw-text-[#C51F3E]">*</span>}
    </label>
  );
}
